/* ==========================================================================
   TALAII — talaii-global.js
   JS global (todas las páginas): navbar, marquees, wishlist, reveals.
   La intro GSAP del hero vive en talaii-hero-intro.js (solo home).
   ========================================================================== */
(function () {
  "use strict";

  var prefersReduced = window.matchMedia(
    "(prefers-reduced-motion: reduce)",
  ).matches;

  /* ================= [0] NAVBAR ================= */
  var nav = document.getElementById("nav");
  if (nav) {
    var lastScroll = 0;
    var navTransparent = nav.getAttribute("data-transparent") === "true";

    var onScrollNav = function () {
      var y = window.scrollY;
      var heroZone = window.innerHeight * 0.85;
      // Solo alterna transparente si la sección lo permite (home con hero)
      if (navTransparent) {
        nav.classList.toggle("nav--transparent", y < heroZone);
        nav.classList.toggle("is-scrolled", y >= heroZone);
      } else {
        nav.classList.add("is-scrolled");
      }
      if (y > lastScroll && y > window.innerHeight) {
        nav.classList.add("is-hidden");
      } else {
        nav.classList.remove("is-hidden");
      }
      lastScroll = y;
    };
    onScrollNav();
    window.addEventListener("scroll", onScrollNav, { passive: true });
  }

  /* --- Menú móvil (drawer) --- */
  var burger = document.getElementById("burger");
  var mobileMenu = document.getElementById("mobileMenu");
  var menuClose = document.getElementById("menuClose");
  if (burger && mobileMenu) {
    var openMenu = function () {
      mobileMenu.classList.add("is-open");
      mobileMenu.setAttribute("aria-hidden", "false");
      burger.setAttribute("aria-expanded", "true");
      document.body.style.overflow = "hidden";
    };
    var closeMenu = function () {
      mobileMenu.classList.remove("is-open");
      mobileMenu.setAttribute("aria-hidden", "true");
      burger.setAttribute("aria-expanded", "false");
      document.body.style.overflow = "";
    };
    burger.addEventListener("click", openMenu);
    if (menuClose) menuClose.addEventListener("click", closeMenu);
    mobileMenu.querySelectorAll(".mobile-menu__link").forEach(function (link) {
      link.addEventListener("click", closeMenu);
    });
    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape") closeMenu();
    });
  }

  /* ================= MARQUEES (rAF) ================= */
  document.documentElement.classList.add("js-marquee");
  var marqueeTracks = [];
  document.querySelectorAll(".marquee__track").forEach(function (track) {
    var group = track.querySelector(".marquee__group");
    if (!group) return;
    track.appendChild(group.cloneNode(true));
    var baseDir = track.classList.contains("marquee__track--reverse") ? -1 : 1;
    marqueeTracks.push({
      el: track,
      groupWidth: 0,
      x: 0,
      baseDir: baseDir,
      dir: baseDir,
      curDir: baseDir,
    });
    // Nota: el marquee NO se pausa al pasar el mouse. En su lugar, las fotos de
    // producto hacen cross-fade a su variante alterna (ver CSS .marq-swap).
  });

  var measureMarquees = function () {
    marqueeTracks.forEach(function (m) {
      var g = m.el.querySelector(".marquee__group");
      m.groupWidth = g ? g.getBoundingClientRect().width : 0;
    });
  };
  measureMarquees();
  window.addEventListener("resize", measureMarquees);
  window.addEventListener("load", measureMarquees);

  var MARQUEE_SPEED = 0.4;
  var marqueePrevScroll = window.scrollY;

  var animateMarquees = function () {
    var y = window.scrollY;
    var scrollingUp = y < marqueePrevScroll - 0.5;
    var scrollingDown = y > marqueePrevScroll + 0.5;
    marqueePrevScroll = y;
    marqueeTracks.forEach(function (m) {
      if (scrollingUp) m.dir = -m.baseDir;
      else if (scrollingDown) m.dir = m.baseDir;
      m.curDir += (m.dir - m.curDir) * 0.06;
      if (m.groupWidth > 0) {
        m.x -= MARQUEE_SPEED * m.curDir;
        if (m.x <= -m.groupWidth) m.x += m.groupWidth;
        if (m.x > 0) m.x -= m.groupWidth;
        m.el.style.transform = "translateX(" + m.x + "px)";
      }
    });
    requestAnimationFrame(animateMarquees);
  };
  if (marqueeTracks.length) requestAnimationFrame(animateMarquees);

  /* ================= WISHLIST (localStorage) ================= */
  var WISH_KEY = "talaii_wishlist";
  function wishGet() {
    try {
      return JSON.parse(localStorage.getItem(WISH_KEY) || "[]");
    } catch (e) {
      return [];
    }
  }
  function wishSet(list) {
    localStorage.setItem(WISH_KEY, JSON.stringify(list));
    wishRenderCount();
    wishRenderDrop();
    wishSyncButtons();
  }
  function wishHas(handle) {
    return wishGet().some(function (p) {
      return p.handle === handle;
    });
  }
  function wishToggle(item) {
    var list = wishGet();
    var i = list.findIndex(function (p) {
      return p.handle === item.handle;
    });
    if (i >= 0) {
      list.splice(i, 1);
    } else {
      list.push(item);
    }
    wishSet(list);
  }
  function wishRenderCount() {
    var el = document.getElementById("wishCount");
    if (!el) return;
    var n = wishGet().length;
    el.textContent = n;
    el.hidden = n === 0;
  }
  function wishSyncButtons() {
    document.querySelectorAll(".look__wish").forEach(function (btn) {
      var h = btn.getAttribute("data-handle");
      btn.classList.toggle("is-active", h && wishHas(h));
    });
  }
  function wishRenderDrop() {
    var listEl = document.getElementById("wishDropList");
    var emptyEl = document.getElementById("wishDropEmpty");
    var moreEl = document.getElementById("wishDropMore");
    if (!listEl) return;
    var list = wishGet();
    listEl.innerHTML = "";
    if (!list.length) {
      if (emptyEl) emptyEl.hidden = false;
      if (moreEl) moreEl.hidden = true;
      return;
    }
    if (emptyEl) emptyEl.hidden = true;
    // Últimos 3 (los más recientes primero)
    var last3 = list.slice(-3).reverse();
    last3.forEach(function (p) {
      var a = document.createElement("a");
      a.className = "wish-drop__item";
      a.href = p.url || "#";
      a.innerHTML =
        '<img src="' +
        (p.image || "") +
        '" alt="" width="46" height="60">' +
        '<span><span class="wish-drop__item-name">' +
        (p.title || "") +
        "</span>" +
        '<span class="wish-drop__item-price">' +
        (p.price || "") +
        "</span></span>";
      listEl.appendChild(a);
    });
    if (moreEl) moreEl.hidden = list.length <= 3 ? true : false;
    // Mostrar "ver todos" siempre que haya al menos 1 (para ir a la página completa)
    if (moreEl && list.length >= 1) moreEl.hidden = false;
  }

  // Click en los corazones de las cards
  document.querySelectorAll(".look__wish").forEach(function (btn) {
    btn.addEventListener("click", function (e) {
      e.preventDefault();
      e.stopPropagation();
      var item = {
        handle:
          btn.getAttribute("data-handle") || btn.getAttribute("data-title"),
        title: btn.getAttribute("data-title") || "",
        price: btn.getAttribute("data-price") || "",
        image: btn.getAttribute("data-image") || "",
        url: btn.getAttribute("data-url") || "#",
      };
      if (!item.handle) {
        btn.classList.toggle("is-active");
        return;
      }
      wishToggle(item);
    });
  });

  // Desplegable de favoritos en la navbar
  var wishToggleBtn = document.getElementById("wishToggle");
  var wishDrop = document.getElementById("wishDrop");
  if (wishToggleBtn && wishDrop) {
    wishToggleBtn.addEventListener("click", function (e) {
      e.stopPropagation();
      var open = wishDrop.classList.toggle("is-open");
      wishToggleBtn.setAttribute("aria-expanded", open ? "true" : "false");
      wishDrop.setAttribute("aria-hidden", open ? "false" : "true");
    });
    document.addEventListener("click", function (e) {
      if (!wishDrop.contains(e.target) && e.target !== wishToggleBtn) {
        wishDrop.classList.remove("is-open");
        wishToggleBtn.setAttribute("aria-expanded", "false");
      }
    });
  }

  wishRenderCount();
  wishRenderDrop();
  wishSyncButtons();

  // Página de favoritos (/pages/favoritos)
  var favGrid = document.getElementById("favoritesGrid");
  var favEmpty = document.getElementById("favoritesEmpty");
  if (favGrid) {
    var renderFavPage = function () {
      var list = wishGet();
      favGrid.innerHTML = "";
      if (!list.length) {
        if (favEmpty) favEmpty.hidden = false;
        return;
      }
      if (favEmpty) favEmpty.hidden = true;
      list
        .slice()
        .reverse()
        .forEach(function (p) {
          var card = document.createElement("article");
          card.className = "favorites__card";
          card.innerHTML =
            '<a href="' +
            (p.url || "#") +
            '"><div class="favorites__media">' +
            '<img src="' +
            (p.image || "") +
            '" alt="' +
            (p.title || "") +
            '">' +
            "</div></a>" +
            '<button type="button" class="favorites__remove" data-handle="' +
            p.handle +
            '" aria-label="Quitar de favoritos">' +
            '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/></svg>' +
            "</button>" +
            '<div class="favorites__info"><a href="' +
            (p.url || "#") +
            '">' +
            '<h3 class="favorites__name">' +
            (p.title || "") +
            "</h3>" +
            '<p class="favorites__price">' +
            (p.price || "") +
            "</p></a></div>";
          favGrid.appendChild(card);
        });
      favGrid.querySelectorAll(".favorites__remove").forEach(function (btn) {
        btn.addEventListener("click", function () {
          var list2 = wishGet().filter(function (p) {
            return p.handle !== btn.getAttribute("data-handle");
          });
          wishSet(list2);
          renderFavPage();
        });
      });
    };
    renderFavPage();
  }

  /* ================= PDP (página de producto) ================= */
  var pdp = document.querySelector(".pdp");
  if (pdp) {
    // Galería: miniatura → imagen principal
    var mainImg = document.getElementById("pdpMainImg");
    document.querySelectorAll(".pdp__thumb").forEach(function (thumb) {
      thumb.addEventListener("click", function () {
        var full = thumb.getAttribute("data-full");
        if (mainImg && full) {
          // La imagen principal lleva srcset (image_tag). Un srcset presente GANA
          // sobre src, asi que hay que vaciarlo o el cambio de miniatura no se ve.
          mainImg.removeAttribute("srcset");
          mainImg.removeAttribute("sizes");
          mainImg.src = full;
        }
        document.querySelectorAll(".pdp__thumb").forEach(function (t) {
          t.classList.remove("is-active");
        });
        thumb.classList.add("is-active");
      });
    });

    // Cantidad +/-
    var qtyInput = document.getElementById("pdpQty");
    var qtyMinus = document.getElementById("qtyMinus");
    var qtyPlus = document.getElementById("qtyPlus");
    if (qtyInput) {
      if (qtyMinus)
        qtyMinus.addEventListener("click", function () {
          var v = parseInt(qtyInput.value, 10) || 1;
          if (v > 1) qtyInput.value = v - 1;
        });
      if (qtyPlus)
        qtyPlus.addEventListener("click", function () {
          var v = parseInt(qtyInput.value, 10) || 1;
          qtyInput.value = v + 1;
        });
    }

    // Selección de talla (pills) → actualiza variante + precio + botón
    var variantData = [];
    try {
      var vScript = document.getElementById("pdpVariantJson");
      if (vScript) variantData = JSON.parse(vScript.textContent);
    } catch (e) {}
    var pills = pdp.querySelectorAll(".pdp__pill input");
    var variantSelect = document.getElementById("pdpVariantId");
    var priceEl = document.getElementById("pdpPrice");
    var addBtn = document.getElementById("pdpAdd");

    function selectedOptions() {
      var opts = [];
      pdp.querySelectorAll(".pdp__option").forEach(function (group) {
        var checked = group.querySelector("input:checked");
        if (checked) opts.push(checked.value);
      });
      return opts;
    }
    function updateVariant() {
      if (!variantData.length) return;
      var opts = selectedOptions();
      var match = variantData.find(function (v) {
        return v.options.every(function (o, i) {
          return o === opts[i];
        });
      });
      if (!match) return;
      if (variantSelect) variantSelect.value = match.id;
      if (priceEl) priceEl.innerHTML = match.price_html || priceEl.innerHTML;
      if (addBtn) {
        var span = addBtn.querySelector("span");
        if (match.available) {
          addBtn.disabled = false;
          if (span) span.textContent = "Añadir al carrito";
        } else {
          addBtn.disabled = true;
          if (span) span.textContent = "Agotado";
        }
      }
      // La barra fija se actualiza AQUI, dentro de la unica funcion que ya
      // sabia la variante seleccionada. Una segunda rutina propia acabaria
      // mostrando un precio distinto al del boton real.
      var stickyPrice = document.getElementById("pdpStickyPrice");
      var stickyAdd = document.getElementById("pdpStickyAdd");
      if (stickyPrice && match.price_html)
        stickyPrice.innerHTML = match.price_html;
      if (stickyAdd) {
        stickyAdd.disabled = !match.available;
        stickyAdd.textContent = match.available ? "Añadir" : "Agotado";
      }
    }
    pills.forEach(function (input) {
      input.addEventListener("change", function () {
        // marca visual de la pill seleccionada dentro de su grupo
        var group = input.closest(".pdp__pills");
        group.querySelectorAll(".pdp__pill").forEach(function (p) {
          p.classList.remove("is-selected");
        });
        input.closest(".pdp__pill").classList.add("is-selected");
        updateVariant();
      });
    });

    // Barra de compra fija: aparece cuando el bloque de compra real sale de
    // pantalla. Se usa IntersectionObserver y NO un listener de scroll: el
    // listener obligaria a leer geometria en cada pixel scrolleado y eso es
    // trabajo en el hilo principal justo cuando el usuario esta scrolleando.
    var stickyBar = document.getElementById("pdpSticky");
    var buyBlock = pdp.querySelector(".pdp__buy");
    if (stickyBar && buyBlock && "IntersectionObserver" in window) {
      var showSticky = function (show) {
        stickyBar.setAttribute("data-hidden", show ? "false" : "true");
        // aria-hidden acompana al estado visual: mientras esta fuera de
        // pantalla no debe anunciarse ni recibir foco por tabulacion.
        stickyBar.setAttribute("aria-hidden", show ? "false" : "true");
      };
      new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            // Solo cuando el bloque de compra queda por ARRIBA del viewport.
            // Si esta por debajo (aun no se ha llegado a el) la barra no
            // aparece: taparia contenido antes de que el usuario vea el
            // producto.
            var salioPorArriba =
              !entry.isIntersecting && entry.boundingClientRect.top < 0;
            showSticky(salioPorArriba);
          });
        },
        { threshold: 0 },
      ).observe(buyBlock);
    }

    // Wishlist en la PDP (usa el mismo sistema)
    var pdpWish = document.getElementById("pdpWish");
    if (pdpWish) {
      var syncPdpWish = function () {
        var h = pdpWish.getAttribute("data-handle");
        pdpWish.classList.toggle("is-active", h && wishHas(h));
      };
      pdpWish.addEventListener("click", function () {
        wishToggle({
          handle: pdpWish.getAttribute("data-handle"),
          title: pdpWish.getAttribute("data-title"),
          price: pdpWish.getAttribute("data-price"),
          image: pdpWish.getAttribute("data-image"),
          url: pdpWish.getAttribute("data-url"),
        });
        syncPdpWish();
      });
      syncPdpWish();
    }
  }

  /* ================= POPUPS DEL FOOTER (guía tallas / política) ================= */
  document.querySelectorAll("[data-popup]").forEach(function (btn) {
    btn.addEventListener("click", function () {
      var pop = document.getElementById(
        "popup-" + btn.getAttribute("data-popup"),
      );
      if (pop) {
        pop.classList.add("is-open");
        pop.setAttribute("aria-hidden", "false");
        document.body.style.overflow = "hidden";
      }
    });
  });
  document.querySelectorAll(".footer-popup").forEach(function (pop) {
    pop.querySelectorAll("[data-popup-close]").forEach(function (el) {
      el.addEventListener("click", function () {
        pop.classList.remove("is-open");
        pop.setAttribute("aria-hidden", "true");
        document.body.style.overflow = "";
      });
    });
  });
  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape")
      document.querySelectorAll(".footer-popup.is-open").forEach(function (p) {
        p.classList.remove("is-open");
        p.setAttribute("aria-hidden", "true");
        document.body.style.overflow = "";
      });
  });

  /* ================= CART DRAWER + TOAST (AJAX, sin recargar) ================= */
  var drawer = document.getElementById("cartDrawer");
  var toastEl = document.getElementById("talaiiToast");
  var toastTimer;

  function showToast(msg) {
    if (!toastEl) return;
    var t = document.getElementById("talaiiToastText");
    if (t && msg) t.textContent = msg;
    toastEl.classList.add("is-visible");
    toastEl.setAttribute("aria-hidden", "false");
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () {
      toastEl.classList.remove("is-visible");
      toastEl.setAttribute("aria-hidden", "true");
    }, 2600);
  }

  function money(cents) {
    // Formato COP: $ 109.900
    var v = cents / 100;
    return (
      "$ " +
      v.toLocaleString("es-CO", {
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
      })
    );
  }

  function openDrawer(title) {
    if (!drawer) return;
    var t = document.getElementById("cartDrawerTitle");
    if (t) t.textContent = title || "Tu carrito";
    drawer.classList.add("is-open");
    drawer.setAttribute("aria-hidden", "false");
    document.body.style.overflow = "hidden";
  }
  function closeDrawer() {
    if (!drawer) return;
    drawer.classList.remove("is-open");
    drawer.setAttribute("aria-hidden", "true");
    document.body.style.overflow = "";
  }

  function updateCartCount(count) {
    document.querySelectorAll(".nav__cart-count").forEach(function (el) {
      el.textContent = count;
      el.hidden = count === 0;
    });
    // Si no existía el badge (carrito vacío al cargar), lo creamos
    if (count > 0 && !document.querySelector(".nav__cart-count")) {
      var cartIcon = document.querySelector(".nav__icon--cart");
      if (cartIcon) {
        var b = document.createElement("span");
        b.className = "nav__cart-count";
        b.textContent = count;
        cartIcon.appendChild(b);
      }
    }
  }

  function renderDrawer(cart) {
    var body = document.getElementById("cartDrawerBody");
    var sub = document.getElementById("cartDrawerSubtotal");
    if (!body) return;
    body.innerHTML = "";
    if (!cart.items || !cart.items.length) {
      body.innerHTML =
        '<p class="cart-drawer__empty">Tu carrito está vacío.</p>';
    } else {
      cart.items.forEach(function (it) {
        var el = document.createElement("div");
        el.className = "cart-drawer__item";
        var variant =
          it.variant_title && it.variant_title.indexOf("Default") === -1
            ? '<p class="cart-drawer__item-variant">' +
              it.variant_title +
              "</p>"
            : "";
        el.innerHTML =
          '<img class="cart-drawer__item-img" src="' +
          (it.image || "") +
          '" alt="" width="74" height="92">' +
          '<div class="cart-drawer__item-info">' +
          '<a class="cart-drawer__item-name" href="' +
          it.url +
          '">' +
          it.product_title +
          "</a>" +
          variant +
          '<div class="cart-drawer__item-bottom">' +
          '<span class="cart-drawer__qty">' +
          '<button type="button" data-dk="' +
          it.key +
          '" data-da="minus" aria-label="Menos">&minus;</button>' +
          "<span>" +
          it.quantity +
          "</span>" +
          '<button type="button" data-dk="' +
          it.key +
          '" data-da="plus" aria-label="Más">+</button>' +
          "</span>" +
          '<span class="cart-drawer__item-price">' +
          money(it.final_line_price) +
          "</span>" +
          "</div>" +
          "</div>";
        body.appendChild(el);
      });
    }
    if (sub) sub.textContent = money(cart.total_price);
    updateCartCount(cart.item_count);
  }

  function fetchCartAndRender() {
    return fetch("/cart.js", { headers: { Accept: "application/json" } })
      .then(function (r) {
        return r.json();
      })
      .then(function (cart) {
        renderDrawer(cart);
        return cart;
      });
  }

  if (drawer) {
    var dClose = document.getElementById("cartDrawerClose");
    var dOverlay = document.getElementById("cartDrawerOverlay");
    if (dClose) dClose.addEventListener("click", closeDrawer);
    if (dOverlay) dOverlay.addEventListener("click", closeDrawer);
    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape") closeDrawer();
    });

    // El icono del carrito de la navbar abre el drawer (no navega)
    document.querySelectorAll(".nav__icon--cart").forEach(function (link) {
      link.addEventListener("click", function (e) {
        e.preventDefault();
        // OJO: no pasar openDrawer como callback directo — recibiría el objeto
        // del carrito como 'title' y pintaría [object Object].
        fetchCartAndRender().then(function () {
          openDrawer("Tu carrito");
        });
      });
    });

    // Cantidad +/- dentro del drawer
    drawer.addEventListener("click", function (e) {
      var btn = e.target.closest("[data-dk]");
      if (!btn) return;
      var key = btn.getAttribute("data-dk");
      var action = btn.getAttribute("data-da");
      var span = btn.parentElement.querySelector("span");
      var current = span ? parseInt(span.textContent, 10) || 1 : 1;
      var next = action === "plus" ? current + 1 : current - 1;
      if (next < 0) next = 0;
      fetch("/cart/change.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ id: key, quantity: next }),
      })
        .then(function (r) {
          return r.json();
        })
        .then(function (cart) {
          renderDrawer(cart);
        });
    });
  }

  // Interceptar el "Añadir al carrito" de la PDP → AJAX + drawer
  var pdpForm = document.getElementById("pdpForm");
  if (pdpForm) {
    pdpForm.addEventListener("submit", function (e) {
      e.preventDefault();
      var btn = document.getElementById("pdpAdd");
      var span = btn ? btn.querySelector("span") : null;
      var originalText = span ? span.textContent : "";
      if (btn) {
        btn.disabled = true;
      }
      if (span) span.textContent = "Añadiendo…";

      var formData = new FormData(pdpForm);
      fetch("/cart/add.js", { method: "POST", body: formData })
        .then(function (r) {
          if (!r.ok) throw new Error("add failed");
          return r.json();
        })
        .then(function () {
          return fetchCartAndRender();
        })
        .then(function () {
          if (span) span.textContent = originalText || "Añadir al carrito";
          if (btn) btn.disabled = false;
          showToast("Añadido al carrito");
          openDrawer("Añadido al carrito");
        })
        .catch(function () {
          if (span) span.textContent = originalText || "Añadir al carrito";
          if (btn) btn.disabled = false;
          showToast("No se pudo añadir. Inténtalo de nuevo.");
        });
    });
  }

  /* ================= CARRITO (página) ================= */
  var cartSection = document.querySelector(".cart__form");
  if (cartSection) {
    var changeCartLine = function (key, quantity) {
      fetch("/cart/change.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ id: key, quantity: quantity }),
      })
        .then(function (r) {
          return r.json();
        })
        .then(function () {
          window.location.reload();
        })
        .catch(function () {
          window.location.reload();
        });
    };

    cartSection.addEventListener("click", function (e) {
      var btn = e.target.closest(".cart__qty-btn, .cart__remove");
      if (!btn) return;
      e.preventDefault();
      var key = btn.getAttribute("data-key");
      if (btn.classList.contains("cart__remove")) {
        changeCartLine(key, 0);
        return;
      }
      var input = cartSection.querySelector(
        '.cart__qty-input[data-key="' + key + '"]',
      );
      var current = input ? parseInt(input.value, 10) || 1 : 1;
      var action = btn.getAttribute("data-action");
      var next = action === "plus" ? current + 1 : current - 1;
      if (next < 0) next = 0;
      changeCartLine(key, next);
    });

    cartSection.addEventListener("change", function (e) {
      var input = e.target.closest(".cart__qty-input");
      if (!input) return;
      var key = input.getAttribute("data-key");
      var qty = parseInt(input.value, 10);
      if (isNaN(qty) || qty < 0) qty = 0;
      changeCartLine(key, qty);
    });
  }

  /* ================= BÚSQUEDA (predictive nativa Shopify) ================= */
  var searchToggle = document.getElementById("searchToggle");
  var searchPanel = document.getElementById("searchPanel");
  var searchInput = document.getElementById("searchInput");
  var searchClose = document.getElementById("searchClose");
  var searchResults = document.getElementById("searchResults");

  if (searchToggle && searchPanel) {
    var openSearch = function () {
      searchPanel.classList.add("is-open");
      searchPanel.setAttribute("aria-hidden", "false");
      searchToggle.setAttribute("aria-expanded", "true");
      if (searchInput)
        setTimeout(function () {
          searchInput.focus();
        }, 100);
    };
    var closeSearch = function () {
      searchPanel.classList.remove("is-open");
      searchPanel.setAttribute("aria-hidden", "true");
      searchToggle.setAttribute("aria-expanded", "false");
    };
    searchToggle.addEventListener("click", openSearch);
    var searchToggleMobile = document.getElementById("searchToggleMobile");
    if (searchToggleMobile)
      searchToggleMobile.addEventListener("click", openSearch);
    if (searchClose) searchClose.addEventListener("click", closeSearch);
    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape") closeSearch();
    });

    // Predictive search de Shopify
    var searchTimer;
    if (searchInput && searchResults) {
      searchInput.addEventListener("input", function () {
        var q = searchInput.value.trim();
        clearTimeout(searchTimer);
        if (q.length < 2) {
          searchResults.innerHTML = "";
          return;
        }
        searchTimer = setTimeout(function () {
          var url =
            "/search/suggest.json?q=" +
            encodeURIComponent(q) +
            "&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=last";
          fetch(url)
            .then(function (r) {
              return r.json();
            })
            .then(function (data) {
              var products =
                (data.resources &&
                  data.resources.results &&
                  data.resources.results.products) ||
                [];
              searchResults.innerHTML = "";
              products.forEach(function (p) {
                var a = document.createElement("a");
                a.className = "search-result";
                a.href = p.url;
                var img =
                  (p.featured_image && p.featured_image.url) || p.image || "";
                a.innerHTML =
                  '<img src="' +
                  img +
                  '" alt="' +
                  (p.title || "") +
                  '">' +
                  '<div class="search-result__name">' +
                  (p.title || "") +
                  "</div>" +
                  '<div class="search-result__price">' +
                  (p.price || "") +
                  "</div>";
                searchResults.appendChild(a);
              });
            })
            .catch(function () {});
        }, 250);
      });
    }
  }

  /* ================= REVEALS on scroll ================= */
  var reveals = document.querySelectorAll(".reveal");
  if (prefersReduced || !("IntersectionObserver" in window)) {
    reveals.forEach(function (el) {
      el.classList.add("is-visible");
    });
  } else {
    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add("is-visible");
            io.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.15, rootMargin: "0px 0px -8% 0px" },
    );
    reveals.forEach(function (el) {
      io.observe(el);
    });
  }
})();
